import {ApartmentStateDto, ApplicationRequestDto, WohnenAppsClient} from '../http/wohnen-apps';

export enum ApartmentApplicationStep {
    EMPLOYEE, CUSTOMER, APPLICATION, FLATMATES, DOCUMENTS, CONFIRMATION, DONE
}

export class ApplicationService {

    private readonly client: WohnenAppsClient;

    constructor(baseUrl: string) {
        this.client = new WohnenAppsClient({
            BASE: baseUrl,
        });

        window.addEventListener('error', e => this.logClientError(null, 'uncaught-error', e.error));
        window.addEventListener('unhandledrejection', e => this.logClientError(null, 'uncaught-rejection', e.reason));
    }

    saveApplicationData(data: Partial<ApplicationRequestDto>) {
        this.setStorageItem('application-data', {
            customer: data.customer,
            application: data.application,
            flatmates: data.flatmates,
        });
    }

    loadApplicationData(): Partial<ApplicationRequestDto> {
        return this.loadStorageItem('application-data');
    }

    deleteApplicationData() {
        Object.keys(localStorage)
            .filter(key => key.startsWith('application-'))
            .forEach(key => localStorage.removeItem(key));
    }

    private setStorageItem<T>(key: string, data: T) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    private loadStorageItem<T>(key: string): T {
        const data = localStorage.getItem(key);
        if (!data) {
            return null;
        }

        try {
            return JSON.parse(data);
        } catch (e) {
            console.warn(`Error loading data for key '${key}':`, e);
            this.logClientError(null, 'load-application', e);
            return null;
        }
    }

    async sendApplication(apartmentId: string, application: ApplicationRequestDto) {
        return this.client.default.sendApartmentApplication(apartmentId, application);
    }

    getApartmentState(apartmentId: string): Promise<ApartmentStateDto> {
        return this.client.default.getApartmentState(apartmentId);
    }

    startApplication(apartmentId: string, employeeId: string, accessCardNumber: string) {
        return this.client.default.startApartmentApplication(apartmentId, {employeeId, accessCardNumber});
    }

    logClientError(employeeId: string, location: string, error: Error) {
        this.client.default.logClientError({
            employeeId,
            location,
            name: error?.name,
            message: error?.message || error?.toString(),
            stack: error?.stack,
        }).catch(e => console.error('Error logging failed', e));
    }
}
